// Приложение основных страниц. Код сайта регистрируется через совместимый API angular.
export function defineMainApp() {
    /* eslint-disable global-require */
    require('../../angular/controller/controllers');
    require('../../angular/filter/filters');
    require('../../angular/directive/directives');
    require('../../angular/directive/phoneMask');
    require('../../angular/directive/sectionScroll');
    require('../../angular/controller/mainCtrl');
    require('../../angular/service/services');
    require('../../angular/components/labels');
    require('../../angular/components/giftPositions');
    // Меню «Ещё» на основных страницах и на странице оформления заказа.
    require('../../angular/navigation');
    /* eslint-enable global-require */
}
